import $ from 'jquery';
import { eventType } from './../config/settings.js';

function setHandlersForCampaigns() {
	const $exploreContainer = $('#section1');
	const $campaignItems = $exploreContainer.find('.campaign__item');
	$campaignItems.each(function(i) {
		$campaignItems.eq(i).on(eventType, function (e) {
			e.stopPropagation();
			e.preventDefault();
			if ($(this).attr('popup') === 'false') {
				$(location).attr('href', $(this).attr('campaign-url'));
			} else {
				window.open($(this).attr('campaign-url'), '_blank');
			}
		});
	});
}

export default {
	setHandlersForCampaigns
};





// WEBPACK FOOTER //
// ./mobile-core/src/casino/campaigns.js